import {
  Box,
  ClickAwayListener,
  IconButton,
  Popover,
  Typography,
  useTheme,
} from '@mui/material';
import { darken } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Calories = ({
  catalogExtendedAttributes,
  calories,
  mainItem,
  showDisclaimer = true,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const popoverId = open ? 'calories-disclaimer-popover' : undefined;

  useEffect(() => {
    if (!open) return;
    const scrollContainer = document.getElementById('CatalogModal.Content');
    if (!scrollContainer) return;
    const handleScroll = () => setAnchorEl(null);
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => scrollContainer.removeEventListener('scroll', handleScroll);
  }, [open]);

  if (
    catalogExtendedAttributes?.DISPLAY_CALORIES?.toString().toLowerCase() !==
      'true' ||
    (!mainItem &&
      catalogExtendedAttributes?.DISPLAY_ONLY_ITEM_CALORIES?.toString().toLowerCase() ===
        'true')
  )
    return null;

  if (calories == null) return null;

  const bgColor = darken(
    theme.palette.background.paper,
    theme.palette.mode === 'dark' ? 0.35 : 0.1,
  );

  if (mainItem && showDisclaimer) {
    return (
      <Box display="flex" alignItems="center" gap={0.1}>
        <Typography
          data-testid="Calories.Value"
          variant="body2"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {Math.round(calories)} {t('catalog.modal.calories.label')}
        </Typography>
        <IconButton
          size="small"
          aria-label={t('catalog.modal.calories.disclaimer')}
          aria-describedby={popoverId}
          data-testid="Calories.DisclaimerIcon"
          onClick={e => setAnchorEl(e.currentTarget)}
        >
          <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
        </IconButton>
        <Popover
          id={popoverId}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          disableScrollLock
          hideBackdrop
          slotProps={{
            root: { sx: { pointerEvents: 'none' } },
            paper: {
              sx: {
                pointerEvents: 'auto',
                p: 1.5,
                maxWidth: 300,
                backgroundColor: bgColor,
                backgroundImage: 'none',
                overflow: 'visible',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -8,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 0,
                  height: 0,
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: `8px solid ${bgColor}`,
                },
              },
            },
          }}
        >
          <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
            <Typography variant="body2">
              {t('catalog.modal.calories.disclaimer')}
            </Typography>
          </ClickAwayListener>
        </Popover>
      </Box>
    );
  }

  return (
    <Typography
      data-testid="Calories.Value"
      variant="body2"
      sx={{ whiteSpace: 'nowrap' }}
    >
      {Math.round(calories)} {t('catalog.modal.calories.label')}
    </Typography>
  );
};
export default Calories;
